import React, { Component } from 'react'

export default class third extends Component {
    constructor(props){
        super(props);
        this.state = {data:[{
            title:'【智量】拍照量体服务',
            sub:'无处不在的量体服务',
            intro:'正常衣着,环境的情况下通过手机拍照,即可获取准确的身材数据;极大的量体服务效率及范围,帮你构建新的核心竞争力',
            img:require('../image/paizhao.svg')
            },
            {
            title:'【智量】智能量体终端',
            sub:'自带营销功能的量体设备',
            intro:'创新人体数据采集终端,可以极大的节省硬件投入成本.通过硬件+软件的创新结合,帮你快速进入新零售时代',
            img:require('../image/zhineng.svg')
            },
            {
            title:'【智量】智能量体终端',
            sub:'自带营销功能的量体设备',
            intro:'创新人体数据采集终端,可以极大的节省硬件投入成本.通过硬件+软件的创新结合,帮你快速进入新零售时代',
            img:require('../image/zaixiandingzhi.svg')
            }
        ]};
    }

    render() {
        return (
        <div className="container2">
            <div className="title03">
                <div className="titleAll">
                    <div className="title03-1" >产品中心</div>
                    <div className="title03-2">/PRODUCT CENTER</div>
                </div>
                <div className="title03-3">完善的产品组合，提供定制行业一体化解决方案<br/>
                支持云端、sdk、小程序等多种接入方式.</div>
            </div>
            <div className="box2-container">
            {
                this.state.data.map((item,index)=>{
                    return (
                        <div key={index} className="box02">
                            <div className="box02-1">
                                <div className="title03-4">{item.title}</div>
                                <div className="sub">{item.sub}</div>
                                <div className="intro03">{item.intro}</div>
                                <div className="button02">
                                    <div className="liaojie02">了解更多</div>
                                    <img src={global.constants.channel==="mengduo"? require('../image/mengduo/arrow.svg'):require('../image/jiantou.svg')} className="jiantou02"></img>
                                </div>    
                            </div>    
                            <img src={item.img} className="img-2"></img>
                        </div>
                    );
                })
            }
            </div>
        </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/third.js